import { render, staticRenderFns } from "./LegalPrivacy.vue?vue&type=template&id=27e4de03&scoped=true"
import script from "./LegalPrivacy.vue?vue&type=script&lang=js"
export * from "./LegalPrivacy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27e4de03",
  null
  
)

export default component.exports